import ItemTake from "pages/ItemTake/index";
import StockAdjustment from "pages/StockAdjustment";
import { lazy } from "react";

const Home = lazy(() => import("pages/Home"));
const ItemCreation = lazy(() => import("pages/ItemCreation"));
const ItemDetail = lazy(() => import("pages/ItemDetail"));
const PriceChange = lazy(() => import("pages/PriceChange"));
const NotFound = lazy(() => import("pages/404"));
const Role = lazy(() => import("pages/Role"));
const User = lazy(() => import("pages/User"));
const SingleMargin = lazy(() => import("pages/SingleMargin"));
const TieredMargin = lazy(() => import("pages/TieredMargin"));
const LogsSyncMasterData = lazy(() => import("pages/LogsSyncMasterData"));
const VendorHierarchyMapping = lazy(() => import("pages/VendorHierarchyMapping"));
const SizeAttribute = lazy(() => import("pages/SizeAttribute"));
const OtherAttribute = lazy(() => import("pages/OtherAttribute"));
const UniversalAttribute = lazy(() => import("pages/UniversalAttribute"));
const ItemTransfer = lazy(() => import("pages/ItemTransfer"));
const SalesReport = lazy(() => import("pages/SalesReport"));
const InventoryReport = lazy(() => import("pages/InventoryReport"));
const MonthlyBilling = lazy(() => import("pages/MonthlyBilling"));

export default [
  {
    id: "home",
    component: LogsSyncMasterData,
    title: "Home",
    path: "/home",
    exact: false,
  },
  {
    id: "user",
    component: User,
    title: "User",
    path: "/user",
    exact: false,
  },
  {
    id: "role",
    component: Role,
    title: "Role",
    path: "/role",
    exact: false,
  },
  {
    id: "UniversalAttribute",
    component: UniversalAttribute,
    title: "Universal Attribute",
    path: "/UniversalAttribute",
    exact: false,
  },
  {
    id: "OtherAttribute",
    component: OtherAttribute,
    title: "Other Attribute",
    path: "/OtherAttribute",
    exact: false,
  },
  {
    id: "SizeAttribute",
    component: SizeAttribute,
    title: "Size Attribute",
    path: "/SizeAttribute",
    exact: false,
  },
  {
    id: "VendorHierarchy",
    component: VendorHierarchyMapping,
    title: "Vendor Hierarchy",
    path: "/VendorHierarchy",
    exact: false,
  },
  {
    id: "itemcreation",
    component: ItemCreation,
    path: "/itemcreation",
    title: "Item Creation",
    exact: false,
  },
  {
    id: "itemdetail",
    component: ItemDetail,
    path: "/itemdetail",
    title: "Item Detail",
    exact: false,
  },
  {
    id: "itemtransfer",
    component: ItemTransfer,
    path: "/itemtransfer",
    exact: false,
  },
  {
    id: "pricechange",
    component: PriceChange,
    path: "/pricechange",
    title: "Price Change",
    exact: false,
  },
  {
    id: "singlemargin",
    component: SingleMargin,
    path: "/singlemargin",
    title: "Single Margin",
    exact: false,
  },
  {
    id: "tieredmargin",
    component: TieredMargin,
    path: "/tieredmargin",
    title: "Tiered Margin",
    exact: false,
  },
  {
    id: "ItemTake",
    component: ItemTake,
    path: "/itemtake",
    title: "Item Take",
    exact: false
  },
  {
    id: "StockAdjustment",
    component: StockAdjustment,
    path: "/stockadjustment",
    title: "Stock Adjust",
    exact: false
  },
  // {
  //   id: "logssyncmasterdata",
  //   component: LogsSyncMasterData,
  //   path: "/logssyncmasterdata",
  //   title: "Logs Sync Master Data",
  //   exact: false,
  // }
  {
    id: "salesreport",
    component: SalesReport,
    path: "/salesreport",
    title: "Sales Report",
    exact: false,
  },
  {
    id: "inventoryreport",
    component: InventoryReport,
    path: "/inventoryreport",
    title: "Inventory Report",
    exact: false,
  },
  {
    id: "monthlybilling",
    component: MonthlyBilling,
    path: "/monthlybilling",
    title: "Monthly Billing",
    exact: false,
  },
];
